"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AutocompleteMultiSelectFilter;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));

var _utils = require("@alycecom/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _BaseButton = _interopRequireDefault(require("../../../Buttons/BaseButton"));

var _Icon = _interopRequireDefault(require("../../../Icon/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    autocompleteRoot: {
      margin: spacing(2)
    },
    popper: {
      zIndex: 1,
      border: "1px solid ".concat(palette.primary.main),
      borderRadius: 5,
      minWidth: 280,
      maxWidth: 320,
      width: 'auto',
      backgroundColor: palette.common.white,
      marginTop: "".concat(spacing(1), " !important")
    },
    popperDisablePortal: {
      position: 'relative',
      padding: 0
    },
    paper: {
      width: '100%',
      boxShadow: 'none',
      margin: 0,
      borderTop: "2px solid ".concat(palette.grey.dark),
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    searchIcon: {
      color: palette.grey.dark
    },
    inputAutocomplete: {
      padding: '5px !important'
    },
    checkbox: {
      color: palette.primary.main,
      marginRight: spacing(1)
    },
    lockIcon: {
      width: 42,
      height: 42,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: spacing(1)
    },
    disabled: {
      '&:disabled': {
        border: "1px solid ".concat(palette.grey.main)
      }
    }
  };
});
/**
 * Autocomplete multiselect field.
 *
 * @template FieldNameType
 * @param {Object} props
 * @param {string} props.label
 * @param {FieldNameType} props.name
 * @param {IOption[]} props.value
 * @param {IOption[]} props.options
 * @param {boolean} props.disabled
 * @param {boolean} props.isLoading
 * @param {function(FieldNameType, IOption[], IOption, boolean): void} props.onChange
 * @param {() => void} props.onOpen
 * @param {Partial<BoxProps>} props.buttonBoxProps
 * @param {IOverrideClasses} props.overrideClasses
 * @returns {ReactElement}
 */

function AutocompleteMultiSelectFilter(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      value = _ref2.value,
      options = _ref2.options,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      isLoading = _ref2.isLoading,
      onChange = _ref2.onChange,
      _ref2$onOpen = _ref2.onOpen,
      onOpen = _ref2$onOpen === void 0 ? function () {} : _ref2$onOpen,
      _ref2$buttonBoxProps = _ref2.buttonBoxProps,
      buttonBoxProps = _ref2$buttonBoxProps === void 0 ? {
    width: 160,
    mr: 2
  } : _ref2$buttonBoxProps,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses;
  var classes = useStyles();

  var _useTheme = (0, _material.useTheme)(),
      colors = _useTheme.palette;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var open = Boolean(anchorEl);
  var id = open ? "autocomplete-popper-".concat(name) : undefined;
  var buttonLabel = value && value.length > 0 ? "".concat(label, " (").concat(value.length, ")") : label;
  var handleOpenFilter = (0, _react.useCallback)(function (event) {
    onOpen();
    setAnchorEl(event.currentTarget);
  }, [onOpen]);
  var handleCloseFilter = (0, _react.useCallback)(function (event, reason) {
    if (reason === 'toggleInput') {
      return;
    }

    if (anchorEl) {
      anchorEl.focus();
    }

    setAnchorEl(null);
    setInputValue('');
  }, [anchorEl]);
  var handleSelectItem = (0, _react.useCallback)(function (event, values) {
    var checked = value.length < values.length;
    var optionItems = checked ? (0, _ramda.difference)(values, value) : (0, _ramda.difference)(value, values);

    if (!optionItems[0].disabled) {
      onChange(name, values, optionItems[0], checked);
    }
  }, [onChange, name, value]);
  var handleInputChange = (0, _react.useCallback)(function (event, searchValue, reason) {
    if (reason === 'input') {
      setInputValue(searchValue);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, buttonBoxProps, /*#__PURE__*/_react["default"].createElement(_BaseButton["default"], {
    width: "100%",
    variant: "outlined",
    "aria-describedby": id,
    "data-testid": (0, _utils.toUnderscore)("multi-select-filter-".concat(name)),
    color: colors.grey.main,
    hoverColor: colors.grey.main,
    bgColor: colors.common.white,
    borderColor: colors.grey.regular,
    onClick: handleOpenFilter,
    disabled: disabled,
    overrideClass: classes.disabled
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Body-Regular-Left-Inactive"
  }, buttonLabel), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: open ? 'chevron-up' : 'chevron-down'
  })))), /*#__PURE__*/_react["default"].createElement(_material.Popper, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: "bottom-start",
    className: (0, _classnames["default"])(classes.popper, overrideClasses.popper)
  }, /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
    classes: {
      root: classes.autocompleteRoot,
      popper: classes.popper,
      popperDisablePortal: classes.popperDisablePortal,
      paper: classes.paper,
      inputRoot: classes.inputAutocomplete
    },
    id: "autocomplete-".concat(name),
    open: true,
    multiple: true,
    disablePortal: true,
    disableCloseOnSelect: true,
    value: value,
    disabled: disabled,
    loading: isLoading,
    options: options,
    onChange: handleSelectItem,
    onClose: handleCloseFilter,
    onInputChange: handleInputChange,
    inputValue: inputValue,
    getOptionLabel: (0, _react.useCallback)(function (option) {
      return option.label;
    }, []),
    renderOption: function renderOption(props, option, _ref3) {
      var selected = _ref3.selected;
      return /*#__PURE__*/_react["default"].createElement("li", props, option.disabled ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: classes.lockIcon
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        key: option.type ? "".concat(option.type, "-").concat(option.id) : option.id,
        icon: "lock",
        color: "grey.main"
      })) : /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        color: "secondary",
        key: option.type ? "".concat(option.type, "-").concat(option.id) : option.id,
        className: (0, _classnames["default"])(classes.checkbox, overrideClasses === null || overrideClasses === void 0 ? void 0 : overrideClasses.checkbox),
        checked: selected,
        "data-testid": (0, _utils.toUnderscore)("multi-select-filter-checkbox-".concat(name, "-").concat(option.label))
      }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
        pt: "6px",
        "data-testid": (0, _utils.toUnderscore)("multi-select-filter-checkbox-text-".concat(name, "-").concat(option.label))
      }, option.label, "\xA0", option.count && option.count > 0 ? "(".concat(option.count, ")") : ''));
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({}, params, {
        id: "field-search-".concat(name, "-id"),
        name: "search-".concat(name),
        autoFocus: true,
        fullWidth: true,
        variant: "outlined",
        label: "Search ".concat((0, _ramda.toLower)(label)),
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
            position: "start"
          }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
            className: classes.searchIcon
          })),
          endAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoading ? /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
            color: "inherit",
            size: 20
          }) : null)
        })
      }));
    },
    renderTags: function renderTags() {
      return null;
    }
  })));
}